import chroma from 'chroma-js';
import { camelToKebab } from '../../utils/camelToKebab';
import { cleanupHexColors } from './helpers/cleanupHexColors';
import { getTextVariables } from './helpers/getTextVariables';
import sizeVariablesRaw from './sizeVariables.json';
import staticVariables from './staticVariables.json';
import { defaultStaticColors, propertyPickerStaticColors, } from './types';
const sizeVariables = sizeVariablesRaw;
const categoriesKeys = ['ui', 'primary', 'secondary'];
const colorsKeys = ['primary', 'secondary'];
export const useIframeModuleTheme = ({ colors, scales, fonts }) => {
    let theme = Object.assign({}, staticVariables);
    const hexScales = {
        ui: [],
        primary: [],
        secondary: [],
    };
    Object.entries(colors).forEach(([colorKey, value]) => {
        const isDark = chroma(value).get('lab.l') < 70;
        if (colorKey === 'ui') {
            hexScales.ui = chroma
                .scale([value, isDark ? '#ffffff' : '#000000'])
                .mode('lch')
                .colors(11);
        }
        colorsKeys.forEach((typeKey) => {
            hexScales[typeKey] = cleanupHexColors([
                ...chroma.scale(['#000000', colors[typeKey]]).colors(7),
                ...chroma.scale([colors[typeKey], '#ffffff']).colors(7),
            ]);
        });
    });
    categoriesKeys.forEach((category) => {
        hexScales[category].forEach((hex, index) => {
            const id = index * 10;
            theme = Object.assign(Object.assign(Object.assign({}, theme), { [`--color-${category}-${id}`]: hex }), getTextVariables({ key: category, id, color: hex }));
        });
    });
    [...defaultStaticColors, ...propertyPickerStaticColors].forEach((colorKey) => {
        if (!colors[colorKey])
            return;
        theme = Object.assign(Object.assign(Object.assign({}, theme), { [`--color-${camelToKebab(colorKey)}`]: colors[colorKey] }), getTextVariables({ key: camelToKebab(colorKey), color: colors[colorKey] }));
    });
    Object.entries(sizeVariables).forEach(([categoryKey, values]) => {
        Object.entries(values).forEach(([sizeKey, size]) => {
            theme[`--${categoryKey}-${sizeKey}`] = `${Math.round(size * scales[categoryKey] * 100) / 100}px`;
        });
    });
    Object.entries(fonts).forEach(([key, value]) => {
        theme[`--font-${key}`] = value;
    });
    Object.entries(theme).map(([prefix, properties]) => {
        document.documentElement.style.setProperty(`${prefix}`, String(properties));
    });
    return theme;
};
export * from './types';
//# sourceMappingURL=useIframeModuleTheme.js.map